import React from 'react';
import preicon from 'assets/icons/leftSideArrow.svg';
import nexticon from 'assets/icons/rightSideArrow.svg';
import line from 'assets/images/line.svg';
import dayjs from 'dayjs';
import { Tooltip } from '@mantine/core';

const Mailtimezone = (props) => {
  const { date, curretmail, totalmails, setDate, setIsUpdated } = props;

  return (
    <div className='flex justify-between items-center p-4 my-2 2xl:my-3 3xl:my-4 '>
      <div>
        <h1 className='text-primary text-xs xl:text-sm font-semibold 2xl:text-sm 3xl:text-lg'>
          {dayjs(date).format('YYYY-MM-DD') ===
          dayjs(new Date()).format('YYYY-MM-DD')
            ? 'Today'
            : dayjs(date).format(' MMMM ,YYYY')}
        </h1>
      </div>
      <img src={line} alt='line' className='w-24 2xl:w-28 3xl:w-32 xl:w-10' />
      <div className='flex justify-around gap-x-4'>
        <div className=''>
          <p className='text-585858 text-xs xl:text-base 2xl:text-sm 3xl:text-lg whitespace-nowrap'>
            {curretmail} <span> of </span> {totalmails}
          </p>
        </div>
        <div className='flex justify-between items-center gap-x-6'>
          <Tooltip
            label='prev'
            classNames={{
              body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
            }}
            radius='md'
            position='bottom'
          >
            <img
              onClick={() => {
                setIsUpdated((prev) => !prev);
                setDate((prev) => dayjs(prev).subtract(1, 'month'));
              }}
              src={preicon}
              alt='previousicon'
              className='w-3 h-3 2xl:w-4 2xl:h-4 3xl:h-5 cursor-pointer'
            />
          </Tooltip>
          {
            <Tooltip
              label='next'
              classNames={{
                body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
              }}
              radius='md'
              position='bottom'
              className={` ${
                dayjs(date).format('YYYY-MM-DD') !==
                dayjs(new Date()).format('YYYY-MM-DD')
                  ? ''
                  : 'invisible'
              }`}
            >
              <img
                onClick={() => {
                  setIsUpdated((prev) => !prev);
                  setDate((prev) => dayjs(prev).add(1, 'month'));
                }}
                src={nexticon}
                alt='nexticon'
                className={`w-3 h-3 2xl:w-4 2xl:h-4 3xl:h-5 cursor-pointer ${
                  dayjs(date).format('YYYY-MM-DD') !==
                  dayjs(new Date()).format('YYYY-MM-DD')
                    ? ''
                    : 'invisible'
                }`}
              />
            </Tooltip>
          }
        </div>
      </div>
    </div>
  );
};

export default Mailtimezone;
